import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";

export const CtaBand = ({ title = "Focus on driving.", accent = "We'll run the rest.", to = "/contact", label = "Start an Inquiry" }) => (
  <section data-testid="cta-band" className="grain relative overflow-hidden bg-[#111111]">
    <div className="mx-auto flex max-w-7xl flex-col items-start gap-10 px-5 py-20 md:flex-row md:items-end md:justify-between md:px-8 md:py-28">
      <Reveal>
        <p className="font-overline text-[10px] uppercase tracking-[0.35em] text-[#e63946] md:text-[11px]">
          Start the conversation
        </p>
        <h2 className="font-display mt-5 text-4xl font-extrabold leading-[1.02] tracking-tight text-white sm:text-5xl lg:text-6xl">
          {title}
          <br />
          <span className="text-stroke-light">{accent}</span>
        </h2>
      </Reveal>
      <Reveal delay={0.15}>
        <Link
          to={to}
          data-testid="cta-band-button"
          className="group inline-flex items-center gap-3 bg-[#e63946] px-8 py-4 text-[13px] font-semibold uppercase tracking-[0.16em] text-white transition-colors duration-300 hover:bg-white hover:text-[#111111]"
        >
          {label}
          <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </Link>
      </Reveal>
    </div>
  </section>
);
